module.exports = __webpack_public_path__ + "img/alternate-linkden-icon.10e7cc8d.svg";